import { ArgumentNullException } from '../../../../utility/exception/argument-null.exception';
import { IdValueObject } from '../../../../utility/model/id-value-object.model';

export class ActivityId extends IdValueObject {
  static create(value: string): ActivityId {
    if (value === null) {
      throw new ArgumentNullException();
    }
    return new ActivityId(value);
  }
}
